import { fbGet, fbSet } from "./firebase";

export const addLog = async (action, details, userName="", role="", extra={}) => {
  try {
    const now = new Date();
    const logsDoc = await fbGet("bekvam","logs");
    const existing = logsDoc?.entries || [];
    const log = {
      id: Date.now(),
      timestamp: now.toISOString(),
      time: now.toLocaleString("ar-KW",{timeZone:"Asia/Kuwait",hour:"2-digit",minute:"2-digit",second:"2-digit"}),
      date: now.toLocaleDateString("ar-KW",{timeZone:"Asia/Kuwait",day:"2-digit",month:"2-digit",year:"numeric"}),
      action, details, user: userName, role, extra
    };
    const updated = [log, ...existing].slice(0,500);
    await fbSet("bekvam","logs",{entries: updated});
  } catch(e){ console.error("addLog:",e); }
};
